import {
     CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM,
     CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT,
     CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
     CONST_CONSULTANT_MISSION_HORAIRE_APREM_UNIQUEMENT,
     CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE,
     CONST_CONSULTANT_MISSION_HORAIRE_MATIN_UNIQUEMENT,
     CONST_CONSULTANT_MISSION_HORAIRE_NUIT_UNIQUEMENT,
     CONST_CONSULTANT_MISSION_HORAIRE_OPTIONS_FOR_SELECT2,
     CONST_CONSULTANT_MISSION_TYPE_PERMANENT,
     CONST_CONSULTANT_MISSION_TYPE_PONCTUEL,
     CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR,
} from "@common-constants/*"
import { Form, Formik, FormikHelpers } from "formik"
import { IConsultantMissionModel, IHttpErrorResponseModel } from "@common-models/*"
import { toast } from "react-toastify"
import { AxiosError } from "axios"
import MyAlert from "@common-utils/MyAlert"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import React from "react"
import { setConsultantMissionDetails } from "../../../core/_requests"
import * as Yup from "yup"
import { ISetConsultantMissionDetailsRequestModel } from "../../../core/_models"
import MyDateDayMonthYearFormField from "@common-components/fields/MyDateDayMonthYearFormField"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import MyTimeFormField from "@common-components/fields/MyTimeFormField"

const ConsultantEditMissionDetailsForm = ({ mission, callback = () => {} }: IConsultantEditMissionFormPropsModel) => {
     // Form schema
     const validationSchema = Yup.object().shape({
          type: Yup.string().label(`"Type"`).required(),
          dateDebutValidite: Yup.string().label(`"Date début de validité"`).required(),
          dateFinValidite: Yup.string().label(`"Date fin de validité"`).required(),
          typeHoraire: Yup.string().label("Horaires").required(),
          horaireMatinDebut: Yup.string()
               .label("Début")
               .when("typeHoraire", {
                    is: (val: any) =>
                         [
                              CONST_CONSULTANT_MISSION_HORAIRE_MATIN_UNIQUEMENT,
                              CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
                         ].includes(val),
                    then: schema => schema.required(),
               }),
          horaireMatinFin: Yup.string()
               .label("Fin")
               .when("typeHoraire", {
                    is: (val: any) =>
                         [
                              CONST_CONSULTANT_MISSION_HORAIRE_MATIN_UNIQUEMENT,
                              CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
                         ].includes(val),
                    then: schema => schema.required(),
               }),
          horaireApremDebut: Yup.string()
               .label("Début")
               .when("typeHoraire", {
                    is: (val: any) =>
                         [
                              CONST_CONSULTANT_MISSION_HORAIRE_APREM_UNIQUEMENT,
                              CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
                         ].includes(val),
                    then: schema => schema.required(),
               }),
          horaireApremFin: Yup.string()
               .label("Fin")
               .when("typeHoraire", {
                    is: (val: any) =>
                         [
                              CONST_CONSULTANT_MISSION_HORAIRE_APREM_UNIQUEMENT,
                              CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
                         ].includes(val),
                    then: schema => schema.required(),
               }),
          horaireNuitDebut: Yup.string()
               .label("Début")
               .when("typeHoraire", {
                    is: (val: any) =>
                         [
                              CONST_CONSULTANT_MISSION_HORAIRE_NUIT_UNIQUEMENT,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT,
                         ].includes(val),
                    then: schema => schema.required(),
               }),
          horaireNuitFin: Yup.string()
               .label("Fin")
               .when("typeHoraire", {
                    is: (val: any) =>
                         [
                              CONST_CONSULTANT_MISSION_HORAIRE_NUIT_UNIQUEMENT,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
                              CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT,
                         ].includes(val),
                    then: schema => schema.required(),
               }),
     })

     // Form initial values
     const initialValues: ISetConsultantMissionDetailsRequestModel = {
          dateDebutValidite: mission.dateDebutValidite?.format("YYYY-MM-DD"),
          dateFinValidite: mission.dateFinValidite?.format("YYYY-MM-DD"),
          type: mission.type,
          typeHoraire: mission.typeHoraire || undefined,
          horaireMatinDebut: mission.horaireMatinDebut || undefined,
          horaireMatinFin: mission.horaireMatinFin || undefined,
          horaireApremDebut: mission.horaireApremDebut || undefined,
          horaireApremFin: mission.horaireApremFin || undefined,
          horaireNuitDebut: mission.horaireNuitDebut || undefined,
          horaireNuitFin: mission.horaireNuitFin || undefined,
     }

     // Formik handle submit
     function handleSubmit(values: ISetConsultantMissionDetailsRequestModel, helpers: FormikHelpers<ISetConsultantMissionDetailsRequestModel>) {
          helpers.setStatus(null)

          setConsultantMissionDetails(mission.id as number, values)
               .then(r => {
                    toast.success("Vos modifications ont bien été prises en compte.")
                    callback(r.data)
               })
               .catch((e: AxiosError) => {
                    const error: IHttpErrorResponseModel = e.response?.data

                    // Set form errors
                    if (error?.code === CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR && error?.errors) {
                         for (const key in error.errors) helpers.setFieldError(key, error.errors[key])
                    }

                    // Set form global status and notify user using a toast
                    helpers.setStatus(error?.detail)
                    toast.error(error?.detail, { autoClose: false })

                    // Stop submit loader
                    helpers.setSubmitting(false)
               })
               .finally(() => helpers.setSubmitting(false))
     }

     // Form
     return (
          <>
               <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
                    {helpers => {
                         return (
                              <Form noValidate autoComplete="off">
                                   {helpers.status && (
                                        <MyAlert type={"danger"} classNames={"mb-4"}>
                                             {helpers.status}
                                        </MyAlert>
                                   )}

                                   <div className="d-flex flex-column gap-4">
                                        {/* Type */}
                                        <MySelectFormField
                                             name={"type"}
                                             formikProps={helpers}
                                             validationSchema={validationSchema}
                                             options={[
                                                  { value: CONST_CONSULTANT_MISSION_TYPE_PERMANENT, label: "Permanent" },
                                                  { value: CONST_CONSULTANT_MISSION_TYPE_PONCTUEL, label: "Ponctuel" },
                                             ]}
                                             placeholder={"Type"}
                                             label={"Type"}
                                             classNameLabel={"col-lg-4"}
                                             classNameField={"col-lg-8"}
                                        />

                                        {/* Date début de validité */}
                                        <MyDateDayMonthYearFormField
                                             name={"dateDebutValidite"}
                                             validationSchema={validationSchema}
                                             formikProps={helpers}
                                             maxDate={helpers.values.dateFinValidite}
                                             label={"Date de début de validité"}
                                             placeholder={"Date de début"}
                                             classNameLabel={"col-lg-4"}
                                             classNameField={"col-lg-8"}
                                        />

                                        {/* Date fin de validité */}
                                        <MyDateDayMonthYearFormField
                                             name={"dateFinValidite"}
                                             formikProps={helpers}
                                             validationSchema={validationSchema}
                                             minDate={helpers.values.dateDebutValidite}
                                             label={"Date de fin de validité"}
                                             placeholder={"Date de fin"}
                                             classNameLabel={"col-lg-4"}
                                             classNameField={"col-lg-8"}
                                        />

                                        {/* Type horaire */}
                                        <MySelectFormField
                                             name={"typeHoraire"}
                                             formikProps={helpers}
                                             validationSchema={validationSchema}
                                             options={CONST_CONSULTANT_MISSION_HORAIRE_OPTIONS_FOR_SELECT2}
                                             placeholder={"Type"}
                                             label={"Horaires"}
                                             classNameLabel={"col-lg-4"}
                                             classNameField={"col-lg-8"}
                                        />

                                        {helpers.values.typeHoraire && (
                                             <div className={"p-4 border border-dashed text-gray-600"}>
                                                  <h4 className={"mb-4 text-gray-600"}>
                                                       {CONST_CONSULTANT_MISSION_HORAIRE_OPTIONS_FOR_SELECT2.find(item => item.value === helpers.values.typeHoraire)?.label}
                                                  </h4>

                                                  <div className="separator separator-dashed mb-6" />

                                                  {/* Plages (2-8 / 3-8)*/}
                                                  {[
                                                       CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT,
                                                       CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM,
                                                       CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
                                                  ].includes(helpers.values.typeHoraire!) && (
                                                       <>
                                                            <div className="row mt-1">
                                                                 <label className={"fs-6 fw-bolder text-gray-900 required col-lg-4 d-flex align-items-center"}>
                                                                      {helpers.values.typeHoraire === "HORAIRE_ALTERNE_3_PLAGES" ? "Plage 1" : "Matin"}
                                                                 </label>
                                                                 <div className={"col-lg-8"}>
                                                                      <div className="row">
                                                                           <div className="col">
                                                                                <MyTimeFormField
                                                                                     name={"horaireMatinDebut"}
                                                                                     formikProps={helpers}
                                                                                     validationSchema={validationSchema}
                                                                                     placeholder={"Début"}
                                                                                     maxTime={helpers.values.horaireMatinFin}
                                                                                />
                                                                           </div>
                                                                           <div className="col">
                                                                                <MyTimeFormField
                                                                                     name={"horaireMatinFin"}
                                                                                     formikProps={helpers}
                                                                                     validationSchema={validationSchema}
                                                                                     placeholder={"Fin"}
                                                                                     minTime={helpers.values.horaireMatinDebut}
                                                                                />
                                                                           </div>
                                                                      </div>
                                                                 </div>
                                                            </div>

                                                            {helpers.values.typeHoraire === "HORAIRE_ALTERNE_3_PLAGES" && (
                                                                 <>
                                                                      <div className="row mt-1">
                                                                           <label className={"fs-6 fw-bolder text-gray-900 required col-lg-4 d-flex align-items-center"}>
                                                                                Plage 2
                                                                           </label>
                                                                           <div className={"col-lg-8"}>
                                                                                <div className="row">
                                                                                     <div className="col">
                                                                                          <MyTimeFormField
                                                                                               name={"horaireApremDebut"}
                                                                                               formikProps={helpers}
                                                                                               validationSchema={validationSchema}
                                                                                               placeholder={"Début"}
                                                                                               maxTime={helpers.values.horaireApremFin}
                                                                                          />
                                                                                     </div>
                                                                                     <div className="col">
                                                                                          <MyTimeFormField
                                                                                               name={"horaireApremFin"}
                                                                                               formikProps={helpers}
                                                                                               validationSchema={validationSchema}
                                                                                               placeholder={"Fin"}
                                                                                               minTime={helpers.values.horaireApremDebut}
                                                                                          />
                                                                                     </div>
                                                                                </div>
                                                                           </div>
                                                                      </div>
                                                                      <div className="row mt-1">
                                                                           <label className={"fs-6 fw-bolder text-gray-900 required col-lg-4 d-flex align-items-center"}>
                                                                                Plage 3
                                                                           </label>
                                                                           <div className={"col-lg-8"}>
                                                                                <div className="row">
                                                                                     <div className="col">
                                                                                          <MyTimeFormField
                                                                                               name={"horaireNuitDebut"}
                                                                                               formikProps={helpers}
                                                                                               validationSchema={validationSchema}
                                                                                               placeholder={"Début"}
                                                                                               maxTime={helpers.values.horaireNuitFin}
                                                                                          />
                                                                                     </div>
                                                                                     <div className="col">
                                                                                          <MyTimeFormField
                                                                                               name={"horaireNuitFin"}
                                                                                               formikProps={helpers}
                                                                                               validationSchema={validationSchema}
                                                                                               placeholder={"Fin"}
                                                                                               minTime={helpers.values.horaireNuitDebut}
                                                                                          />
                                                                                     </div>
                                                                                </div>
                                                                           </div>
                                                                      </div>
                                                                 </>
                                                            )}

                                                            {helpers.values.typeHoraire === "HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM" && (
                                                                 <>
                                                                      <div className="row mt-1">
                                                                           <label className={"fs-6 fw-bolder text-gray-900 required col-lg-4 d-flex align-items-center"}>
                                                                                Après-midi
                                                                           </label>
                                                                           <div className={"col-lg-8"}>
                                                                                <div className="row">
                                                                                     <div className="col">
                                                                                          <MyTimeFormField
                                                                                               name={"horaireApremDebut"}
                                                                                               formikProps={helpers}
                                                                                               validationSchema={validationSchema}
                                                                                               placeholder={"Début"}
                                                                                               maxTime={helpers.values.horaireApremFin}
                                                                                          />
                                                                                     </div>
                                                                                     <div className="col">
                                                                                          <MyTimeFormField
                                                                                               name={"horaireApremFin"}
                                                                                               formikProps={helpers}
                                                                                               validationSchema={validationSchema}
                                                                                               placeholder={"Fin"}
                                                                                               minTime={helpers.values.horaireApremDebut}
                                                                                          />
                                                                                     </div>
                                                                                </div>
                                                                           </div>
                                                                      </div>
                                                                 </>
                                                            )}

                                                            {helpers.values.typeHoraire === "HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT" && (
                                                                 <>
                                                                      <div className="row mt-1">
                                                                           <label className={"fs-6 fw-bolder text-gray-900 required col-lg-4 d-flex align-items-center"}>
                                                                                Nuit
                                                                           </label>
                                                                           <div className={"col-lg-8"}>
                                                                                <div className="row">
                                                                                     <div className="col">
                                                                                          <MyTimeFormField
                                                                                               name={"horaireNuitDebut"}
                                                                                               formikProps={helpers}
                                                                                               validationSchema={validationSchema}
                                                                                               placeholder={"Début"}
                                                                                               maxTime={helpers.values.horaireNuitFin}
                                                                                          />
                                                                                     </div>
                                                                                     <div className="col">
                                                                                          <MyTimeFormField
                                                                                               name={"horaireNuitFin"}
                                                                                               formikProps={helpers}
                                                                                               validationSchema={validationSchema}
                                                                                               placeholder={"Fin"}
                                                                                               minTime={helpers.values.horaireNuitDebut}
                                                                                          />
                                                                                     </div>
                                                                                </div>
                                                                           </div>
                                                                      </div>
                                                                 </>
                                                            )}
                                                       </>
                                                  )}

                                                  {helpers.values.typeHoraire === CONST_CONSULTANT_MISSION_HORAIRE_NUIT_UNIQUEMENT && (
                                                       <div className="row mt-1">
                                                            <div className="col">
                                                                 <MyTimeFormField
                                                                      name={"horaireNuitDebut"}
                                                                      formikProps={helpers}
                                                                      validationSchema={validationSchema}
                                                                      placeholder={"Début"}
                                                                      maxTime={helpers.values.horaireNuitDebut}
                                                                 />
                                                            </div>
                                                            <div className="col">
                                                                 <MyTimeFormField
                                                                      name={"horaireNuitFin"}
                                                                      formikProps={helpers}
                                                                      validationSchema={validationSchema}
                                                                      placeholder={"Fin"}
                                                                      minTime={helpers.values.horaireNuitFin}
                                                                 />
                                                            </div>
                                                       </div>
                                                  )}

                                                  {helpers.values.typeHoraire === CONST_CONSULTANT_MISSION_HORAIRE_APREM_UNIQUEMENT && (
                                                       <div className="row mt-1">
                                                            <div className="col">
                                                                 <MyTimeFormField
                                                                      name={"horaireApremDebut"}
                                                                      formikProps={helpers}
                                                                      validationSchema={validationSchema}
                                                                      placeholder={"Début"}
                                                                      maxTime={helpers.values.horaireApremDebut}
                                                                 />
                                                            </div>
                                                            <div className="col">
                                                                 <MyTimeFormField
                                                                      name={"horaireApremFin"}
                                                                      formikProps={helpers}
                                                                      validationSchema={validationSchema}
                                                                      placeholder={"Fin"}
                                                                      minTime={helpers.values.horaireApremFin}
                                                                 />
                                                            </div>
                                                       </div>
                                                  )}

                                                  {helpers.values.typeHoraire === CONST_CONSULTANT_MISSION_HORAIRE_MATIN_UNIQUEMENT && (
                                                       <div className="row mt-1">
                                                            <div className="col">
                                                                 <MyTimeFormField
                                                                      name={"horaireMatinDebut"}
                                                                      formikProps={helpers}
                                                                      validationSchema={validationSchema}
                                                                      placeholder={"Début"}
                                                                      maxTime={helpers.values.horaireMatinDebut}
                                                                 />
                                                            </div>
                                                            <div className="col">
                                                                 <MyTimeFormField
                                                                      name={"horaireMatinFin"}
                                                                      formikProps={helpers}
                                                                      validationSchema={validationSchema}
                                                                      placeholder={"Fin"}
                                                                      minTime={helpers.values.horaireMatinFin}
                                                                 />
                                                            </div>
                                                       </div>
                                                  )}

                                                  {helpers.values.typeHoraire === CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE && (
                                                       <>
                                                            <div className="row mt-1">
                                                                 <label className={"fs-6 fw-bolder text-gray-900 required col-lg-4 d-flex align-items-center"}>Matin</label>
                                                                 <div className={"col-lg-8"}>
                                                                      <div className="row">
                                                                           <div className="col">
                                                                                <MyTimeFormField
                                                                                     name={"horaireMatinDebut"}
                                                                                     formikProps={helpers}
                                                                                     validationSchema={validationSchema}
                                                                                     placeholder={"Début"}
                                                                                     maxTime={helpers.values.horaireMatinDebut}
                                                                                />
                                                                           </div>
                                                                           <div className="col">
                                                                                <MyTimeFormField
                                                                                     name={"horaireMatinFin"}
                                                                                     formikProps={helpers}
                                                                                     validationSchema={validationSchema}
                                                                                     placeholder={"Fin"}
                                                                                     minTime={helpers.values.horaireMatinFin}
                                                                                />
                                                                           </div>
                                                                      </div>
                                                                 </div>
                                                            </div>

                                                            <div className="row mt-1">
                                                                 <label className={"fs-6 fw-bolder text-gray-900 required col-lg-4 d-flex align-items-center"}>Après-midi</label>
                                                                 <div className={"col-lg-8"}>
                                                                      <div className="row">
                                                                           <div className="col">
                                                                                <MyTimeFormField
                                                                                     name={"horaireApremDebut"}
                                                                                     formikProps={helpers}
                                                                                     validationSchema={validationSchema}
                                                                                     placeholder={"Début"}
                                                                                     maxTime={helpers.values.horaireApremDebut}
                                                                                />
                                                                           </div>
                                                                           <div className="col">
                                                                                <MyTimeFormField
                                                                                     name={"horaireApremFin"}
                                                                                     formikProps={helpers}
                                                                                     validationSchema={validationSchema}
                                                                                     placeholder={"Fin"}
                                                                                     minTime={helpers.values.horaireApremFin}
                                                                                />
                                                                           </div>
                                                                      </div>
                                                                 </div>
                                                            </div>
                                                       </>
                                                  )}
                                             </div>
                                        )}
                                   </div>

                                   {/* Submit button */}
                                   <div className={"d-flex justify-content-end"}>
                                        <button className={"btn btn-sm btn-primary d-inline-flex align-items-center"} type={"submit"} disabled={helpers.isSubmitting}>
                                             {!helpers.isSubmitting ? <>Appliquer les modifications</> : <MySimpleSpinner size={"sm"} />}
                                        </button>
                                   </div>
                              </Form>
                         )
                    }}
               </Formik>
          </>
     )
}

interface IConsultantEditMissionFormPropsModel {
     mission: IConsultantMissionModel
     callback: (val: IConsultantMissionModel) => void
}

export default ConsultantEditMissionDetailsForm
